// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3wTv4","col":"styles_col__2HOg3"};